import { STANDARD_BRANCH } from '@festina-life/api'
import type { ConfigurableServer, Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useAllConciseBranches } from './useAllConciseBranches'
import { useStandardComponentConciseBranch } from './useStandardComponentConciseBranch'

export const useConciseBranch = ({
  server,
  branchName,
  shouldFallbackToStandard,
}: {
  server: ConfigurableServer
  branchName: Optional<string>
  shouldFallbackToStandard: boolean
}) => {
  const conciseBranches = useAllConciseBranches()
  const configComponentConciseBranch = useMemo(
    () =>
      branchName && branchName !== STANDARD_BRANCH
        ? conciseBranches[server]?.find(
            (specification) => specification.name === branchName,
          )
        : undefined,
    [branchName, conciseBranches, server],
  )
  const standardComponentConciseBranch = useStandardComponentConciseBranch(
    (!!branchName && branchName === STANDARD_BRANCH) ||
      shouldFallbackToStandard,
  )

  return useMemo(
    () => configComponentConciseBranch ?? standardComponentConciseBranch,
    [configComponentConciseBranch, standardComponentConciseBranch],
  )
}
